import React, { Component } from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
const ModalConfirmation = props => /*#__PURE__*/React.createElement(Modal, {
  isOpen: props.showModal,
  toggle: props.closeModal,
  backdrop: "static"
}, /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("div", {
  className: "text-center"
}, props.msg, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
  className: "otto__margin_right",
  color: "success",
  onClick: props.onConfirmation,
  disabled: props.disabled || false
}, "Yes"), /*#__PURE__*/React.createElement(Button, {
  onClick: props.closeModal
}, "No"))));
export default ModalConfirmation;